import React from "react";
import Section from "./Section";

const StyleCard = ({ image, text }) => (
  <div className="flex flex-col items-center">
    <div className="w-40 h-40 bg-n-7 border border-n-1/15 rounded-xl overflow-hidden mb-4">
      <img src={image} alt={text} className="w-full h-full object-cover" />
    </div>
    <p className="text-n-4 text-sm">{text}</p>
  </div>
);

const ConsistentStyleSection = ({ styles }) => {
  const rows = [];
  for (let i = 0; i < styles.length; i += 4) {
    rows.push(styles.slice(i, i + 4));
  }

  return (
    <Section crosses>
      <div className="container">
        <h2 className="h2 mb-8 text-center">Consistent Styles</h2>
        <div className="flex flex-col gap-8">
          {rows.map((row, rowIndex) => (
            <div className="flex gap-8 justify-center" key={rowIndex}>
              {row.map((style, index) => (
                <StyleCard key={index} image={style.image} text={style.text} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default ConsistentStyleSection;
